var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895429 0.895431 0 2 0H598C599.105 0 600 0.895431 600 2V200H0V2Z",
    fill: "#212429"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 552,
    height: 176,
    transform: "translate(24 24)",
    fill: "#212429"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M398.243 78.2597L404.968 141.254L440.214 177.174L481.788 148.818L500.71 87.9456L451.395 63.62L398.243 78.2597Z",
    fill: "#19C1CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M399.869 61.747L398.243 78.2587L451.227 63.6457L500.713 87.916L502.339 71.4043L453.298 47.0695L399.869 61.747Z",
    fill: "#008096"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M398.243 78.2601L404.968 141.254L440.213 177.174L451.249 63.6421L398.243 78.2601Z",
    fill: "#19C1CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M451.242 65.1764L440.214 177.173L481.683 148.865C481.683 148.865 468.632 127.144 468.322 112.641C467.48 72.9048 451.242 65.1764 451.242 65.1764Z",
    fill: "#3BE5EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.533 108.154L401.783 108.005L405.658 140.983L440.583 176.457L439.687 177.345L404.459 141.563L400.533 108.154Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.847 71.5811L482.367 61.96L482.831 61.0149L502.962 70.958L501.332 87.5157L500.288 87.4129L501.847 71.5811Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.365 62.7973L501.28 87.5128L500.885 88.3157L451.282 63.7548L441.243 66.7222L440.991 65.8634L451.365 62.7973Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.053 86.1802C483.412 85.5647 484.199 85.3569 484.812 85.716C488.193 87.6972 492.391 92.3673 491.254 100.184C491.152 100.889 490.499 101.377 489.797 101.275C489.094 101.173 488.608 100.518 488.711 99.8127C489.662 93.2715 486.213 89.5261 483.515 87.9448C482.902 87.5857 482.695 86.7957 483.053 86.1802Z",
    fill: "#3BE5EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M230.59 107.097L230.617 89.4083L242.283 89L242.056 106.992L258.088 101.739L261.609 112.356L245.357 117.551L255.152 131.152L246.681 138.551L236.063 124.492L226.412 138.066L217.123 131.795L226.744 117.038L210.461 112.666L213.854 101.779L230.59 107.097Z",
    fill: "#FFEDC6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M230.34 107.097L230.367 89.4083L242.033 89L241.806 106.992L257.838 101.739L261.552 112.4H242.033L237.104 99.96L230.34 107.097Z",
    fill: "#FFB341"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M226.4 117.295L217 131.749L226.4 138.675C231.603 127.9 229.902 139.082 226.4 117.295Z",
    fill: "#FFDD99"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M288.129 107.097L288.155 89.4083L299.821 89L299.595 106.992L315.627 101.739L319.147 112.356L302.895 117.551L312.691 131.152L304.22 138.551L293.601 124.492L283.95 138.066L274.662 131.795L284.282 117.038L268 112.666L271.392 101.779L288.129 107.097Z",
    fill: "#FFEDC6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M287.879 107.097L287.905 89.4083L299.571 89L299.345 106.992L315.377 101.739L319.091 112.4H299.571L294.643 99.96L287.879 107.097Z",
    fill: "#FFB341"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M283.939 117.295L274.538 131.749L283.939 138.675C289.142 127.9 287.441 139.082 283.939 117.295Z",
    fill: "#FFDD99"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.129 107.097L116.155 89.4083L127.821 89L127.595 106.992L143.627 101.739L147.147 112.356L130.895 117.551L140.691 131.152L132.22 138.551L121.601 124.492L111.95 138.066L102.662 131.795L112.282 117.038L96 112.666L99.3922 101.779L116.129 107.097Z",
    fill: "#FFEDC6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M115.879 107.097L115.905 89.4083L127.571 89L127.345 106.992L143.377 101.739L147.091 112.4H127.571L122.643 99.96L115.879 107.097Z",
    fill: "#FFB341"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.939 117.295L102.538 131.749L111.939 138.675C117.142 127.9 115.441 139.082 111.939 117.295Z",
    fill: "#FFDD99"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M345.668 107.097L345.694 89.4083L357.36 89L357.134 106.992L373.166 101.739L376.686 112.356L360.435 117.551L370.23 131.152L361.759 138.551L351.14 124.492L341.489 138.066L332.201 131.795L341.821 117.038L325.539 112.666L328.931 101.779L345.668 107.097Z",
    fill: "#FFCD6B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M345.418 107.097L345.444 89.4083L357.11 89L356.884 106.992L372.916 101.739L376.63 112.4H357.11L352.182 99.96L345.418 107.097Z",
    fill: "#EB5D2E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M341.478 117.295L332.078 131.749L341.478 138.675C346.681 127.9 344.98 139.082 341.478 117.295Z",
    fill: "#FF8B64"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M173.668 107.097L173.694 89.4083L185.36 89L185.134 106.992L201.166 101.739L204.686 112.356L188.435 117.551L198.23 131.152L189.759 138.551L179.14 124.492L169.489 138.066L160.201 131.795L169.821 117.038L153.539 112.666L156.931 101.779L173.668 107.097Z",
    fill: "#FFEDC6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M173.418 107.097L173.444 89.4083L185.11 89L184.884 106.992L200.916 101.739L204.63 112.4H185.11L180.182 99.96L173.418 107.097Z",
    fill: "#FFB341"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M169.478 117.295L160.078 131.749L169.478 138.675C174.681 127.9 172.98 139.082 169.478 117.295Z",
    fill: "#FFDD99"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M383.51 60L377 67.9307L383.51 77.1508L390.045 67.9476L383.51 60Z",
    fill: "#FFBD28"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M401.493 60L398 64.4052L401.493 69.5282L405 64.4148L401.493 60Z",
    fill: "#FFEDC6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M396.719 72.7042L391.954 78.5793L396.719 85.4085L401.499 78.5907L396.719 72.7042Z",
    fill: "#F4A812"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M485.45 151L481.127 156.363L485.45 162.599L489.789 156.374L485.45 151Z",
    fill: "#FFBD28"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M477.32 157.959L475 160.886L477.32 164.286L479.648 160.891L477.32 157.959Z",
    fill: "#F4A812"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M487.776 164.286L485.563 167.114L487.776 170.402L490 167.12L487.776 164.286Z",
    fill: "#FFEDC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImage);
export default __webpack_public_path__ + "static/media/header_image.bf42f47a8fc0fd76f20dfaf15223ca09.svg";
export { ForwardRef as ReactComponent };